/**
 * 日ビューのタイムグリッドで、同じ列の中で時間が重なるブロックを横に並べるレイアウト
 */

export type LayoutItem = { id: string; column: number; start: Date; end: Date }

export type OverlapSlot = { subCol: number; totalCols: number }

/** 時間軸の幅（px） */
export const TIME_AXIS_PX = 48

/** 列の中でブロックに使える幅（CSS の式）。TODO 列は右端の集中・運動の帯の分だけ細くする */
export const columnInnerWidth = (column: number, laneWidth: number) =>
  `((100% - ${TIME_AXIS_PX}px) / 3 - 4px - ${column === 1 ? laneWidth : 0}px)`

/** 重なりレイアウトに従ったブロックの left / width（CSS の式） */
export const blockHorizontalStyle = (column: number, laneWidth: number, slot: OverlapSlot) => {
  const inner = columnInnerWidth(column, laneWidth)
  return {
    left: `calc(${TIME_AXIS_PX}px + (100% - ${TIME_AXIS_PX}px) * ${column} / 3 + 2px + ${inner} * ${slot.subCol} / ${slot.totalCols})`,
    width: `calc(${inner} / ${slot.totalCols})`,
  }
}

const overlaps = (a: LayoutItem, b: LayoutItem) => a.start < b.end && b.start < a.end

export const computeOverlapLayout = (items: LayoutItem[]) => {
  const layout = new Map<string, OverlapSlot>()

  const byColumn = new Map<number, LayoutItem[]>()
  for (const item of items) {
    byColumn.set(item.column, [...(byColumn.get(item.column) ?? []), item])
  }

  for (const colItems of byColumn.values()) {
    const sorted = [...colItems].sort((a, b) => a.start.getTime() - b.start.getTime())

    // 重なりグループを構築
    const groups: LayoutItem[][] = []
    for (const item of sorted) {
      const group = groups.find((g) => g.some((other) => overlaps(other, item)))
      if (group) group.push(item)
      else groups.push([item])
    }

    // 各グループ内で貪欲法によりサブカラムを割り当て
    for (const group of groups) {
      const assignments: { item: LayoutItem; subCol: number }[] = []
      for (const item of group) {
        let col = 0
        while (assignments.some((a) => a.subCol === col && overlaps(a.item, item))) col++
        assignments.push({ item, subCol: col })
      }
      const totalCols = Math.max(...assignments.map((a) => a.subCol)) + 1
      for (const a of assignments) layout.set(a.item.id, { subCol: a.subCol, totalCols })
    }
  }

  return layout
}
